import { render, staticRenderFns } from "./CardRegister.vue?vue&type=template&id=69b1561e&scoped=true&"
import script from "./CardRegister.vue?vue&type=script&lang=js&"
export * from "./CardRegister.vue?vue&type=script&lang=js&"
import style0 from "./CardRegister.vue?vue&type=style&index=0&id=69b1561e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b1561e",
  null
  
)

export default component.exports